import { Outlet, createFileRoute } from "@tanstack/react-router";

import { m } from "@/paraglide/messages.js";

// Names the "/training" step of the breadcrumb on every page under it, not only on the hub itself.
export const Route = createFileRoute("/(private)/training")({
  loader: () => ({ crumb: m.hub_nav() }),
  component: Outlet,
});
